import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ScheduleSimulation = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const availableDates = [
    { date: '05/12/2024', day: 'Qui', available: true },
    { date: '06/12/2024', day: 'Sex', available: true },
    { date: '07/12/2024', day: 'Sáb', available: false },
    { date: '08/12/2024', day: 'Dom', available: false },
    { date: '09/12/2024', day: 'Seg', available: true },
    { date: '10/12/2024', day: 'Ter', available: true },
    { date: '11/12/2024', day: 'Qua', available: true },
  ];

  const timeSlots = [
    { time: '09:00', available: true },
    { time: '10:00', available: true },
    { time: '11:00', available: false },
    { time: '14:00', available: true },
    { time: '15:00', available: true },
    { time: '16:00', available: true },
    { time: '17:00', available: false },
  ];

  const handleDateSelect = (date) => {
    if (date?.available) {
      setSelectedDate(date?.date);
      setSelectedTime(null);
    }
  };

  const handleTimeSelect = (time) => {
    if (time?.available) {
      setSelectedTime(time?.time);
    }
  };

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="Calendar" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">
              Experimente Agora
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Veja como seus pacientes agendam
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Interface intuitiva que seus pacientes vão adorar usar
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-card rounded-2xl shadow-2xl border border-border overflow-hidden">
          <div className="bg-gradient-to-r from-primary to-blue-700 p-8 text-white">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
                <Icon name="User" size={32} color="#FFFFFF" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">Dra. Maria Santos</h3>
                <p className="text-white/90">Psicóloga Clínica - CRP 06/12345</p>
              </div>
            </div>
            <p className="text-white/90">
              Especialista em Terapia Cognitivo-Comportamental
            </p>
          </div>

          <div className="p-8">
            <div className="mb-8">
              <h4 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
                <Icon name="Calendar" size={20} color="var(--color-primary)" />
                Selecione uma data
              </h4>
              <div className="grid grid-cols-7 gap-2">
                {availableDates?.map((date, index) => (
                  <button
                    key={index}
                    onClick={() => handleDateSelect(date)}
                    disabled={!date?.available}
                    className={`p-3 rounded-lg text-center transition-all ${
                      selectedDate === date?.date
                        ? 'bg-primary text-primary-foreground shadow-md'
                        : date?.available
                        ? 'bg-muted hover:bg-muted/80 text-foreground'
                        : 'bg-muted/50 text-muted-foreground cursor-not-allowed opacity-50'
                    }`}
                  >
                    <div className="text-xs font-medium mb-1">{date?.day}</div>
                    <div className="text-sm font-semibold">
                      {date?.date?.split('/')?.[0]}
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {selectedDate && (
              <div className="mb-8">
                <h4 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                  Horários disponíveis
                </h4>
                <div className="grid grid-cols-4 gap-3">
                  {timeSlots?.map((slot, index) => (
                    <button
                      key={index}
                      onClick={() => handleTimeSelect(slot)}
                      disabled={!slot?.available}
                      className={`p-4 rounded-lg text-center font-medium transition-all ${
                        selectedTime === slot?.time
                          ? 'bg-primary text-primary-foreground shadow-md'
                          : slot?.available
                          ? 'bg-muted hover:bg-muted/80 text-foreground'
                          : 'bg-muted/50 text-muted-foreground cursor-not-allowed opacity-50'
                      }`}
                    >
                      {slot?.time}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {selectedDate && selectedTime && (
              <div className="bg-success/10 border border-success/20 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <Icon name="Check" size={20} color="var(--color-success)" />
                  </div>
                  <div className="flex-1">
                    <h5 className="font-semibold text-foreground mb-2">
                      Horário selecionado
                    </h5>
                    <p className="text-muted-foreground mb-4">
                      {selectedDate} às {selectedTime}
                    </p>
                    <Button
                      variant="success"
                      size="lg"
                      iconName="Calendar"
                      iconPosition="left"
                    >
                      Confirmar Agendamento
                    </Button>
                  </div>
                </div>
              </div>
            )}

            {!selectedDate && (
              <div className="text-center py-8 text-muted-foreground">
                <Icon
                  name="Calendar"
                  size={48}
                  color="var(--color-muted-foreground)"
                  className="mx-auto mb-4 opacity-50"
                />
                <p>Selecione uma data para ver os horários disponíveis</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleSimulation;